import { PageUiNavBar } from 'components/Layout/PageNavBar/PageUiNavBar';
import Couriers from 'pages/couriers/Couriers';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { BundleStatus } from 'types/bundleTypes';
import { getAuthHeadersFromCookie } from '../../lib/AuthClient/cookie';
import { Region } from '../../types/orderTypes';
import BundleMonitor from '../monitor/BundleMonitor';
import { MonitorListWrapper } from '../monitor/MonitorLive/MonitorList/MonitorListWrapper';
import { ScanPerformanceListWithLineHaul } from '../reports/ScanPerformanceList/ScanPerformanceListWithLineHaul/ScanPerformanceListWithLineHaul';
import { Helmet } from 'react-helmet';
import { LineHaulSortList } from '../sort-list/LineHaulSortList';
import SortList from '../sort-list/SortList';
import NewSortList from '../NewSortList/SortList';
import { BundlesList } from './BundlesList';
import { RelabelList } from '../relabel-list/RelabelList';

const MonitorStatusList = [
  BundleStatus.Published,
  BundleStatus.Proposed,
  BundleStatus.Accepted,
];

const CompletedStatusList = [BundleStatus.Completed];

export enum MonitorView {
  MONITOR = 'Monitor',
  COMPLETED = 'Completed',
  COURIERS = 'Couriers',
  BUNDLES = 'Bundles',
  SORTLIST = 'Sortlist',
  SORTLIST2 = 'Sortlist2',
  LINEHAUL = 'Linehaul',
  MONITOROLD = 'MonitorOld',
  SCAN = 'Scan',
  RELABELLING = 'Relabelling',
}

interface Props extends RouteComponentProps {
  region: Region;
  view?: MonitorView;
  limitedAccess?: boolean;
}

class Monitor extends React.PureComponent<Props> {
  componentDidMount() {
    const { region } = this.props;
    sessionStorage.setItem('monitorViewRegion', region);
  }

  render() {
    const { view, region, limitedAccess } = this.props;
    return (
      <>
        <PageUiNavBar
          bars={
            limitedAccess
              ? [
                  {
                    text: `Monitor`,
                    method: () => {
                      this.props.history.push('/monitor');
                    },
                    active: view === MonitorView.MONITOR,
                    page: '/monitor',
                  },
                  {
                    text: `Completed`,
                    method: () => {
                      this.props.history.push('/monitor/completed');
                    },
                    active: view === MonitorView.COMPLETED,
                    page: '/monitor/completed',
                  },
                  {
                    text: `Bundles`,
                    method: () => {
                      this.props.history.push('/monitor/bundles');
                    },
                    active: view === MonitorView.BUNDLES,
                    page: '/monitor/bundles',
                  },
                  {
                    text: `Sort List`,
                    method: () => {
                      this.props.history.push('/monitor/sort-list');
                    },
                    active: false,
                    page: '/monitor/sort-list',
                  },
                ]
              : [
                  {
                    text: `Monitor`,
                    method: () => {
                      this.props.history.push('/monitor');
                    },
                    active: view === MonitorView.MONITOR,
                    page: '/monitor',
                  },
                  {
                    text: `Completed`,
                    method: () => {
                      this.props.history.push('/monitor/completed');
                    },
                    active: view === MonitorView.COMPLETED,
                    page: '/monitor/completed',
                  },
                  {
                    text: `Bundles`,
                    method: () => {
                      this.props.history.push('/monitor/bundles');
                    },
                    active: view === MonitorView.BUNDLES,
                    page: '/monitor/bundles',
                  },
                  {
                    text: `Hub`,
                    method: () => {
                      this.props.history.push('/monitor/hub-bundles');
                    },
                    active: false,
                    page: '/monitor/hub-bundles',
                  },
                  {
                    text: `Sort List`,
                    method: () => {
                      this.props.history.push('/monitor/sort-list');
                    },
                    active: false,
                    page: '/monitor/sort-list',
                  },
                  {
                    text: 'Sort list v2',
                    method: () => {
                      this.props.history.push('/monitor/sort-list2');
                    },
                    active: false,
                    page: '/monitor/sort-list2',
                  },
                  {
                    text: 'Line Haul',
                    method: () => {
                      this.props.history.push('/monitor/line-haul');
                    },
                    active: false,
                    page: '/monitor/line-haul',
                  },
                  {
                    text: 'Scan',
                    method: () => {
                      this.props.history.push('/monitor/scan');
                    },
                    active: false,
                    page: '/monitor/scan',
                  },
                  {
                    text: 'Relabel',
                    method: () => {
                      this.props.history.push('/monitor/relabelling');
                    },
                    active: false,
                    page: '/monitor/relabelling',
                  },
                ]
          }
        />
        <>
          {view === MonitorView.MONITOR && (
            <>
              <Helmet>
                <title>Monitor - Live</title>
              </Helmet>
              <MonitorListWrapper
                statusList={MonitorStatusList}
                region={
                  getAuthHeadersFromCookie().limitedAccess ? region : null
                }
              />
            </>
          )}
          {view === MonitorView.MONITOROLD && (
            <BundlesList
              statusList={MonitorStatusList}
              region={region}
              autoSort
            />
          )}
          {view === MonitorView.COMPLETED && (
            <>
              <Helmet>
                <title>Monitor - Completed</title>
              </Helmet>
              <BundlesList
                statusList={CompletedStatusList}
                region={region}
                completedStatusList={true}
              />
            </>
          )}
          {view === MonitorView.COURIERS && <Couriers region={region} />}
          {view === MonitorView.BUNDLES && (
            <>
              <Helmet>
                <title>Monitor - Bundles</title>
              </Helmet>
              <BundleMonitor region={region} />
            </>
          )}
          {view === MonitorView.SORTLIST && (
            <>
              <Helmet>
                <title>Monitor - Sort List</title>
              </Helmet>
              <SortList region={region} />
            </>
          )}
          {view === MonitorView.SORTLIST2 && (
            <>
              <Helmet>
                <title>Monitor - Sort List v2</title>
              </Helmet>
              <NewSortList region={region} />
            </>
          )}
          {view === MonitorView.LINEHAUL && (
            <>
              <Helmet>
                <title>Monitor - Line Haul</title>
              </Helmet>
              <LineHaulSortList startRegion={region} />
            </>
          )}
          {view === MonitorView.SCAN && (
            <>
              <Helmet>
                <title>Monitor - Scan</title>
              </Helmet>
              <ScanPerformanceListWithLineHaul region={region} />
            </>
          )}
          {view === MonitorView.RELABELLING && (
            <>
              <Helmet>
                <title>Monitor - Relabelling</title>
              </Helmet>
              <RelabelList region={region} />
            </>
          )}
        </>
      </>
    );
  }
}

export default withRouter(Monitor);
